import { useEffect } from "react";
import { Analytics, CommentSection } from "../components"
import ResumeEditor from "../components/ResumeEditor/ResumeEditor";
import { Link, useParams, useNavigate } from 'react-router-dom';
import { Download, Loader2, ArrowLeft } from "lucide-react";
import { useResumesContext } from "../context/resumes-context";
import { log } from "../utils/log_utils";

export const ResumeAnalysis = () => {
    const { resumeId } = useParams();
    const navigate = useNavigate();
    const { fetchResumeDetail, resumes } = useResumesContext();

    useEffect(() => {
        fetchResumeDetail(resumeId);
    }, [resumeId, fetchResumeDetail]);
    
    const data = resumes.find(i => i.id === parseInt(resumeId))
    if (!data) {
        return <div className="flex justify-center items-center h-64">
            <Loader2 className="animate-spin h-12 w-12 text-indigo-600" />
        </div>;
    }

    const { analysis } = data;
    log("selected resume", data, 'ResumeAnalysis-render');

    return (
        <div className="bg-gradient-to-b from-white to-indigo-50 fade-in w-full pb-8">
            <div className="p-4 rounded-xl border flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 bg-white shadow-sm mb-6">
                <div className="flex items-start sm:items-center gap-3">
                    <button 
                        onClick={() => navigate('/myresumes')}
                        className="p-2 hover:bg-gray-100 rounded-full transition-colors sm:mt-0 mt-1 flex-shrink-0"
                        title="Go back"
                    >
                        <ArrowLeft size={20} className="text-gray-600" />
                    </button>
                    <div>
                        <h2 className="text-2xl font-bold text-gray-800">Resume Analysis Report</h2>
                        <p className="text-gray-600">Shared for feedback on the role of: <span className="font-semibold">{data.role}</span></p>
                    </div>
                </div>
                <Link
                    to={`/myresumes/${data.id}/print`}
                    className="inline-flex items-center justify-center gap-2 px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white font-medium text-sm rounded-lg shadow-sm transition-colors w-full sm:w-auto flex-shrink-0"
                >
                    <Download size={18} />
                    Export PDF
                </Link>
            </div>
            <div className="w-full mx-auto flex flex-col gap-8">
                <ResumeEditor resumeId={data.id} />
                
                <Analytics analysis={analysis} viewOnly={true} />
                <CommentSection resumeId={data.id}  />
            </div>
        </div>
    );
};